(function () {
  const startDate = new Date('2025-12-03T00:00:00');
  const endDate = new Date('2025-12-31T23:59:59');
  const now = new Date();

  if (now < startDate || now > endDate) {
    console.log("🎁 FSM Gift : hors période – script désactivé automatiquement");
    return;
  }

  const GIFT_VARIANT_ID = 52865666253132;
  const TRIGGER_QUANTITY = 3;
  const GIFT_QUANTITY_PER_TRIO = 1;
  let isUpdating = false;

  function log(...args) {
    console.log("🎁 FSM Gift:", ...args);
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function updateGiftItems() {
    if (isUpdating) return;
    isUpdating = true;

    await new Promise((resolve) => setTimeout(resolve, 300));
    const cart = await getCart();

    let eligibleQty = 0;
    let giftQtyInCart = 0;

    for (const item of cart.items) {
      const type = item.product_type;
      const isGift = item.variant_id === GIFT_VARIANT_ID;
      const isEligible =
        type === 'Corde Shibari Premium' ||
        type === 'Corde Shibari Francaise';

      if (isGift) giftQtyInCart = item.quantity;
      if (isEligible) eligibleQty += item.quantity;
    }

    const desiredGiftQty = Math.floor(eligibleQty / TRIGGER_QUANTITY) * GIFT_QUANTITY_PER_TRIO;

    const messageEl = document.getElementById('gift-message');
    if (messageEl) {
      let message = '';
      if (desiredGiftQty > 0) {
        message += `🎁 ${desiredGiftQty} corde française BRUTE offerte ajoutée à votre panier.\n`;
      }
      const next = TRIGGER_QUANTITY - (eligibleQty % TRIGGER_QUANTITY || TRIGGER_QUANTITY);
      if (next > 0) {
        message += `🪢 Encore ${next} corde(s) pour en recevoir une ${desiredGiftQty > 0 ? 'autre' : ''} !`;
      }
      messageEl.textContent = message.trim();
    }

    if (giftQtyInCart !== desiredGiftQty) {
      log(`Mise à jour du panier : giftQtyInCart = ${giftQtyInCart}, desired = ${desiredGiftQty}`);
      const formData = { updates: {} };
      formData.updates[GIFT_VARIANT_ID] = desiredGiftQty;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });
    }

    isUpdating = false;
  }

  function listenCartUpdates() {
    updateGiftItems();

    // Mini-cart
    document.addEventListener('cart:updated', updateGiftItems);

    const drawer = document.querySelector('#cart-drawer');
    if (drawer) {
      const observer = new MutationObserver(() => {
        updateGiftItems();
      });
      observer.observe(drawer, { childList: true, subtree: true });
    }

    // Page /cart classique
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
      const observer = new MutationObserver(() => {
        updateGiftItems();
      });
      observer.observe(cartForm, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    log("✅ FSM Gift actif – période promo en cours");
    listenCartUpdates();
  });
})();
